var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 21" }, props),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-attention"] || "oc-icon-status-attention"), d: "M14.1 7.7c0-4.8 0-7.4-6.1-7.4S1.9 2.9 1.9 7.7H.2v13h15.6v-13h-1.7zM8 2.9c3.5 0 3.5.1 3.5 4.8h-7c0-4.8 0-4.8 3.5-4.8zm.8 11.5v2.3c0 .4-.3.8-.7.8s-.8-.3-.8-.7v-2.5c-1-.3-1.3-1.3-.9-2.2s1.5-1.3 2.4-.9c.9.4 1.3 1.5.9 2.4-.3.3-.6.6-.9.8z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/StatusLocked.svg